var _excluded = ["color", "size", "variant", "icon", "isWider", "isExpanded", "isExpandedOnMobile", "isDisabled", "isLoading", "hasError", "to", "href", "openInNewTab", "title", "onClick", "rel", "type", "isOverlappingRelativeContainer", "children", "dataTestId", "dataTName", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useContext } from "react";
import { getLuminance, rgba, shade, tint } from "polished";
import styled, { css } from "styled-components";
import BrandContext from "../../../contexts/BrandContext";
import breakpoint from "../../../utils/breakpoint";
import getBoxShadowBorder from "../../../utils/getBoxShadowBorder";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import Link from "../../quarks/Link";
import IconAtm from "../IconAtm";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
var LoaderSVG = function LoaderSVG(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "0s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  }))));
};
LoaderSVG.defaultProps = {
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor"
};
export { sizeKeys, variantKeys } from "./ButtonAtm.types";
export var defaultProps = {
  color: "primary",
  size: "default",
  variant: "default",
  type: "button"
};
var iconSmallGutterSpace = 1;
var iconDefaultGutterSpace = 2;
export var iconSizeSpace = 2;
export var textButtonHorizontalPaddingDivider = 2;
export var sizes = {
  big: {
    typography: "buttonBig",
    heightSpace: 6,
    paddingSpace: {
      "default": 3,
      wider: 7
    }
  },
  "default": {
    typography: "button",
    heightSpace: 5,
    paddingSpace: {
      "default": 1.5,
      wider: 6
    }
  },
  small: {
    typography: "buttonSmall",
    heightSpace: 4,
    paddingSpace: {
      "default": 1,
      wider: 5
    }
  }
};
export { sizes as buttonAtmSizes, iconSizeSpace as buttonAtmIconSizeSpace };
export var Icon = styled(IconAtm).withConfig({
  componentId: "sc-iui7o6-0"
})(function (_ref) {
  var $buttonSize = _ref.$buttonSize,
    $buttonIsExpanded = _ref.$buttonIsExpanded,
    $color = _ref.$color,
    $variant = _ref.$variant,
    _ref$$buttonIsWider = _ref.$buttonIsWider,
    $buttonIsWider = _ref$$buttonIsWider === void 0 ? false : _ref$$buttonIsWider,
    theme = _ref.theme;
  var iconGutterValue = $buttonSize === "small" ? iconSmallGutterSpace : iconDefaultGutterSpace;
  return css(["margin-right:", ";fill:", ";& path{fill:", ";}", " ", " ", ""], space(iconGutterValue), $variant === "default" ? getIconColor(theme, $color) : getColor(theme, $color), $variant === "default" ? getIconColor(theme, $color) : getColor(theme, $color), !$buttonIsWider && css(["&:last-child{margin-right:0;}"]), $buttonIsWider && css(["", "{margin-right:0;}"], breakpoint("small", "medium")), $buttonIsExpanded && css(["position:absolute;left:", ";"], space(iconGutterValue)));
});
export var Loader = styled(LoaderSVG).withConfig({
  componentId: "sc-iui7o6-1"
})(function (_ref2) {
  var $color = _ref2.$color,
    $variant = _ref2.$variant,
    $size = _ref2.$size,
    theme = _ref2.theme;
  return css(["width:", ";color:", ";"], space(sizes[$size].heightSpace / 2 + 1), $variant === "default" ? getIconColor(theme, $color) : getColor(theme, $color));
});

/*
 * 1. Fixes issue with vertical centering text on a button with default size on IONOS brand
 * */
export var StyledButtonAtm = styled(Link).withConfig({
  componentId: "sc-iui7o6-2"
})(function (_ref3) {
  var _ref3$$color = _ref3.$color,
    $color = _ref3$$color === void 0 ? defaultProps.color : _ref3$$color,
    _ref3$$size = _ref3.$size,
    $size = _ref3$$size === void 0 ? defaultProps.size : _ref3$$size,
    _ref3$$variant = _ref3.$variant,
    $variant = _ref3$$variant === void 0 ? defaultProps.variant : _ref3$$variant,
    $isWider = _ref3.$isWider,
    $isExpanded = _ref3.$isExpanded,
    $isExpandedOnMobile = _ref3.$isExpandedOnMobile,
    $isDisabled = _ref3.$isDisabled,
    $hasIcon = _ref3.$hasIcon,
    $isOverlappingRelativeContainer = _ref3.$isOverlappingRelativeContainer,
    $brand = _ref3.$brand,
    theme = _ref3.theme;
  var colorValue = getColor(theme, $color);
  var shadeValue = getLuminance(colorValue) > 0.08 ? 0.15 : 0.3;
  var _sizes$$size = sizes[$size],
    paddingSpace = _sizes$$size.paddingSpace,
    heightSpace = _sizes$$size.heightSpace;
  var iconGutterValue = $size === "small" ? iconSmallGutterSpace : iconDefaultGutterSpace;
  var background;
  var backgroundHover;
  var backgroundActive;
  if ($variant === "default") {
    background = colorValue;
    backgroundHover = shade(shadeValue, colorValue);
    backgroundActive = tint(0.15, colorValue);
  } else if ($variant === "transparent") {
    background = rgba(colorValue, 0.08);
    backgroundHover = rgba(colorValue, 0.16);
    backgroundActive = rgba(colorValue, 0.24);
  } else {
    background = "transparent";
    backgroundHover = rgba(colorValue, 0.08);
    backgroundActive = rgba(colorValue, 0.16);
  }
  return css(["", ";", ";display:inline-flex;align-items:center;justify-content:center;width:", ";height:", ";margin:0;padding:0 ", ";border:0;border-radius:", ";background-color:", ";box-shadow:", ";line-height:", ";text-align:center;text-decoration:none;cursor:pointer;", " ", " ", " ", " ", " ", " ", ""], cssTextAtm({
    typography: sizes[$size].typography,
    onColor: $isDisabled ? "disabled" : $color,
    emphasis: "high",
    color: $variant !== "default" ? $color : undefined
  }), transition("background-color"), $isExpanded && "100%", space(heightSpace), !$isWider && space(paddingSpace["default"]), unit(theme.borderRadius.large2), $isDisabled ? getColor(theme, "disabled") : background, $variant === "outlined" && getBoxShadowBorder(1, colorValue), $brand === "ionos" && $size === "default" ? "unset" /* 1 */ : "normal", !$isDisabled && css(["&:hover{background-color:", ";}&:active{transition:none;background-color:", ";}"], backgroundHover, backgroundActive), $isDisabled && css(["cursor:not-allowed;"]), $isWider && css(["span{display:grid;grid-template-columns:minmax(", ",", ") auto minmax( ", ",", " );&::before,&::after{content:\"\";}}"], space(paddingSpace["default"]), space(paddingSpace.wider), space(paddingSpace["default"]), space(paddingSpace.wider)), $isWider && $hasIcon && css(["span{display:flex;align-items:center;", "{padding-left:calc( ", " - ", " / 2 - ", " );padding-right:calc( ", " - ", " / 2 );}}"], breakpoint("medium"), space(paddingSpace.wider), space(iconSizeSpace), space(iconGutterValue), space(paddingSpace.wider), space(iconSizeSpace)), $hasIcon && $isExpanded && css(["position:relative;padding:0 ", ";"], space(2 * iconGutterValue + iconSizeSpace)), $isOverlappingRelativeContainer && css(["&::before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;}"]), $isExpandedOnMobile && css(["", "{width:100%;}"], breakpoint("small", "medium")));
});
var ButtonAtm = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? defaultProps.color : _ref4$color,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? defaultProps.size : _ref4$size,
    _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? defaultProps.variant : _ref4$variant,
    icon = _ref4.icon,
    isWider = _ref4.isWider,
    isExpanded = _ref4.isExpanded,
    isExpandedOnMobile = _ref4.isExpandedOnMobile,
    isDisabled = _ref4.isDisabled,
    isLoading = _ref4.isLoading,
    hasError = _ref4.hasError,
    to = _ref4.to,
    href = _ref4.href,
    openInNewTab = _ref4.openInNewTab,
    title = _ref4.title,
    onClick = _ref4.onClick,
    rel = _ref4.rel,
    _ref4$type = _ref4.type,
    type = _ref4$type === void 0 ? defaultProps.type : _ref4$type,
    isOverlappingRelativeContainer = _ref4.isOverlappingRelativeContainer,
    children = _ref4.children,
    dataTestId = _ref4.dataTestId,
    dataTName = _ref4.dataTName,
    className = _ref4.className,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var brand = useContext(BrandContext);
  var isDisabledValue = !!isDisabled;
  var hasErrorValue = !!hasError;
  var commonProps = {
    title: title,
    onClick: onClick,
    $color: hasErrorValue ? "error" : color,
    $size: size,
    $variant: isDisabledValue || hasErrorValue ? "default" : variant,
    $isWider: !!isWider,
    $isExpanded: !!isExpanded,
    $isExpandedOnMobile: !!isExpandedOnMobile,
    $isDisabled: isDisabledValue,
    $hasIcon: !!icon,
    $brand: brand,
    disabled: isDisabledValue,
    $isOverlappingRelativeContainer: !!isOverlappingRelativeContainer,
    "data-test-id": dataTestId,
    "data-t-name": dataTName,
    className: className
  };
  var iconProps = {
    icon: icon,
    sizeSpace: iconSizeSpace,
    $buttonSize: size,
    $buttonIsExpanded: !!isExpanded,
    $color: color,
    $variant: variant
  };
  var loaderJsx = /*#__PURE__*/React.createElement(Loader, {
    $color: color,
    $variant: variant,
    $size: size
  });
  var contentJsx = isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, isWider ? /*#__PURE__*/React.createElement("span", null, loaderJsx) : loaderJsx) : /*#__PURE__*/React.createElement(React.Fragment, null, isWider && icon ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, {
    $buttonIsWider: true
  })), children || null) : /*#__PURE__*/React.createElement(React.Fragment, null, icon ? /*#__PURE__*/React.createElement(Icon, iconProps) : null, children ? /*#__PURE__*/React.createElement("span", null, children) : null));
  if (to || href) {
    return /*#__PURE__*/React.createElement(StyledButtonAtm, _extends({}, commonProps, {
      to: to,
      href: href,
      openInNewTab: openInNewTab,
      rel: rel,
      ref: ref
    }, restProps), contentJsx);
  }
  return /*#__PURE__*/React.createElement(StyledButtonAtm, _extends({}, commonProps, {
    as: "button",
    type: type,
    ref: ref
  }, restProps), contentJsx);
});
export default ButtonAtm;